<script setup lang="ts">
import type { FilterOption } from '@/types/filter.types'

const props = defineProps<{
  item: FilterOption
  isSelected: boolean
}>()
</script>

<template>
  <div class="class-list-item body-md" :class="{ selected: props.isSelected }">
    {{ props.item.name }}
  </div>
</template>

<style scoped>
.class-list-item {
  min-width: 144px;
  height: 56px;
  padding: 0;
  margin: 0;
  border-radius: 8px;
  background: var(--gray-800, #3f4147);
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--gray-600);
  box-sizing: border-box;
}

.selected {
  border-radius: 8px;
  background: linear-gradient(99deg, #e34c46 0%, #b52a67 100%);
  color: var(--white);
}

@media (max-width: 1365px) {
  .class-list-item {
    min-width: auto;
    width: auto;
    height: 36px;
    padding: 6px 16px;
    box-sizing: border-box;
  }
}
</style>
